import Marquee from "@/components/Marquee/Marquee";
import { BrandIconsCPM, BrandIconsJSON } from "@/data/data";
import styles from './BrandLogosMba.module.scss'
import { addStaticSubdomain } from "@/revamp/molecules/ProgramCard/utils";
import UnivoImage from "@/components/common/UnivoImage";

const BrandsLogoMba = ({isCPM=false,isCityPage=false}) => {
  // Cap the marquee at 15 logos to keep the DOM small (each logo renders
  // twice for the seamless loop)
  const BrandIcons = (isCPM ? BrandIconsCPM : BrandIconsJSON);
  return (
    <div className={styles.mainContainer} id="brand_logo">
      <div className={styles.brandsLogoContainer}>
        <h2 className={`${isCityPage ?styles.statebrandHeading : styles.brandHeading}`} id="leading-organization-heading">Employees From Leading Organizations Trust Amity For Lifelong Learning  <hr /></h2>
        {/* duration ≈ content width / 130px per second (each logo ≈ 252px wide) */}
        <Marquee duration={isCPM ? 15 : 100} pauseOnHover={false} className={styles.brandsMarquee}>
          {BrandIcons.map((item, index) => (
            <div className={styles.brandWrapper} key={index}>
              <UnivoImage
                src={addStaticSubdomain(item?.src)}
                alt={item?.alt || "Brand logo"}
                width={200}
                height={94}
                sizes="200px"
                className={styles.brandImage}
                loading="lazy"
                fetchPriority="low"
              />
            </div>
          ))}
        </Marquee>
      </div>
    </div>
  );
};

export default BrandsLogoMba;
